import { colors } from "@/theme/colors";
import { IThemeModeEnum } from "@/theme/types";

export const theme = {
  [IThemeModeEnum.Light]: {
    "primary-950": {
      colorKey: "primary-950",
      colorValue: colors["primary-950"],
    },
    "primary-900": {
      colorKey: "primary-900",
      colorValue: colors["primary-900"],
    },
    "primary-800": {
      colorKey: "primary-800",
      colorValue: colors["primary-800"],
    },
    "primary-700": {
      colorKey: "primary-700",
      colorValue: colors["primary-700"],
    },
    "primary-600": {
      colorKey: "primary-600",
      colorValue: colors["primary-600"],
    },
    "primary-500": {
      colorKey: "primary-500",
      colorValue: colors["primary-500"],
    },
    "primary-400": {
      colorKey: "primary-400",
      colorValue: colors["primary-400"],
    },
    "primary-300": {
      colorKey: "primary-300",
      colorValue: colors["primary-300"],
    },
    "primary-200": {
      colorKey: "primary-200",
      colorValue: colors["primary-200"],
    },
    "primary-100": {
      colorKey: "primary-100",
      colorValue: colors["primary-100"],
    },
    "primary-50": { colorKey: "primary-50", colorValue: colors["primary-50"] },
    "primary-alpha-24": {
      colorKey: "primary-alpha-24",
      colorValue: colors["primary-alpha-24"],
    },
    "primary-alpha-16": {
      colorKey: "primary-alpha-16",
      colorValue: colors["primary-alpha-16"],
    },
    "primary-alpha-10": {
      colorKey: "primary-alpha-10",
      colorValue: colors["primary-alpha-10"],
    },
    "primary-alpha-0": {
      colorKey: "primary-alpha-0",
      colorValue: colors["primary-alpha-0"],
    },
    "primary-base": {
      colorKey: "primary-500",
      colorValue: colors["primary-500"],
    },
    "primary-dark": {
      colorKey: "primary-700",
      colorValue: colors["primary-700"],
    },
    "static-static-black": {
      colorKey: "neutral-500",
      colorValue: colors["neutral-500"],
    },
    "static-static-white": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "bg-strong-950": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "bg-surface-800": {
      colorKey: "neutral-800",
      colorValue: colors["neutral-800"],
    },
    "bg-sub-300": {
      colorKey: "neutral-300",
      colorValue: colors["neutral-300"],
    },
    "bg-soft-200": {
      colorKey: "neutral-200",
      colorValue: colors["neutral-200"],
    },
    "bg-weak-50": {
      colorKey: "neutral-50",
      colorValue: colors["neutral-50"],
    },
    "bg-white-0": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "text-strong-900": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "text-sub-600": {
      colorKey: "neutral-600",
      colorValue: colors["neutral-600"],
    },
    "text-soft-400": {
      colorKey: "neutral-400",
      colorValue: colors["neutral-400"],
    },
    "text-disabled-300": {
      colorKey: "neutral-300",
      colorValue: colors["neutral-300"],
    },
    "text-white-0": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "stroke-strong-950": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "stroke-sub-300": {
      colorKey: "neutral-300",
      colorValue: colors["neutral-300"],
    },
    "stroke-soft-200": {
      colorKey: "neutral-200",
      colorValue: colors["neutral-200"],
    },
    "stroke-white-0": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "icon-strong-950": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "icon-sub-600": {
      colorKey: "neutral-600",
      colorValue: colors["neutral-600"],
    },
    "icon-soft-400": {
      colorKey: "neutral-400",
      colorValue: colors["neutral-400"],
    },
    "icon-disabled-300": {
      colorKey: "neutral-300",
      colorValue: colors["neutral-300"],
    },
    "icon-white-0": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "state-faded-dark": {
      colorKey: "neutral-800",
      colorValue: colors["neutral-800"],
    },
    "state-faded-base": {
      colorKey: "neutral-500",
      colorValue: colors["neutral-500"],
    },
    "state-faded-light": {
      colorKey: "neutral-200",
      colorValue: colors["neutral-200"],
    },
    "state-faded-lighter": {
      colorKey: "neutral-100",
      colorValue: colors["neutral-100"],
    },
    "state-information-dark": {
      colorKey: "blue-950",
      colorValue: colors["blue-950"],
    },
    "state-information-base": {
      colorKey: "blue-500",
      colorValue: colors["blue-500"],
    },
    "state-information-light": {
      colorKey: "blue-200",
      colorValue: colors["blue-200"],
    },
    "state-information-lighter": {
      colorKey: "blue-50",
      colorValue: colors["blue-50"],
    },
    "state-warning-dark": {
      colorKey: "orange-950",
      colorValue: colors["orange-950"],
    },
    "state-warning-base": {
      colorKey: "orange-500",
      colorValue: colors["orange-500"],
    },
    "state-warning-light": {
      colorKey: "orange-200",
      colorValue: colors["orange-200"],
    },
    "state-warning-lighter": {
      colorKey: "orange-50",
      colorValue: colors["orange-50"],
    },
    "state-error-dark": {
      colorKey: "red-950",
      colorValue: colors["red-950"],
    },
    "state-error-base": {
      colorKey: "red-500",
      colorValue: colors["red-500"],
    },
    "state-error-light": {
      colorKey: "red-200",
      colorValue: colors["red-200"],
    },
    "state-error-lighter": {
      colorKey: "red-50",
      colorValue: colors["red-50"],
    },
    "state-success-dark": {
      colorKey: "green-950",
      colorValue: colors["green-950"],
    },
    "state-success-base": {
      colorKey: "green-500",
      colorValue: colors["green-500"],
    },
    "state-success-light": {
      colorKey: "green-200",
      colorValue: colors["green-200"],
    },
    "state-success-lighter": {
      colorKey: "green-50",
      colorValue: colors["green-50"],
    },
    "state-away-dark": {
      colorKey: "yellow-950",
      colorValue: colors["yellow-950"],
    },
    "state-away-base": {
      colorKey: "yellow-500",
      colorValue: colors["yellow-500"],
    },
    "state-away-light": {
      colorKey: "yellow-200",
      colorValue: colors["yellow-200"],
    },
    "state-away-lighter": {
      colorKey: "yellow-50",
      colorValue: colors["yellow-50"],
    },
    "state-feature-dark": {
      colorKey: "purple-950",
      colorValue: colors["purple-950"],
    },
    "state-feature-base": {
      colorKey: "purple-500",
      colorValue: colors["purple-500"],
    },
    "state-feature-light": {
      colorKey: "purple-200",
      colorValue: colors["purple-200"],
    },
    "state-feature-lighter": {
      colorKey: "purple-50",
      colorValue: colors["purple-50"],
    },
    "state-verified-dark": {
      colorKey: "sky-950",
      colorValue: colors["sky-950"],
    },
    "state-verified-base": {
      colorKey: "sky-500",
      colorValue: colors["sky-500"],
    },
    "state-verified-light": {
      colorKey: "sky-200",
      colorValue: colors["sky-200"],
    },
    "state-verified-lighter": {
      colorKey: "sky-50",
      colorValue: colors["sky-50"],
    },
    "state-highlighted-dark": {
      colorKey: "pink-950",
      colorValue: colors["pink-950"],
    },
    "state-highlighted-base": {
      colorKey: "pink-500",
      colorValue: colors["pink-500"],
    },
    "state-highlighted-light": {
      colorKey: "pink-200",
      colorValue: colors["pink-200"],
    },
    "state-highlighted-lighter": {
      colorKey: "pink-50",
      colorValue: colors["pink-50"],
    },
    "state-stable-dark": {
      colorKey: "teal-950",
      colorValue: colors["teal-950"],
    },
    "state-stable-base": {
      colorKey: "teal-500",
      colorValue: colors["teal-500"],
    },
    "state-stable-light": {
      colorKey: "teal-200",
      colorValue: colors["teal-200"],
    },
    "state-stable-lighter": {
      colorKey: "teal-50",
      colorValue: colors["teal-50"],
    },
  },
  [IThemeModeEnum.Dark]: {
    "primary-950": {
      colorKey: "primary-950",
      colorValue: colors["primary-950"],
    },
    "primary-900": {
      colorKey: "primary-900",
      colorValue: colors["primary-900"],
    },
    "primary-800": {
      colorKey: "primary-800",
      colorValue: colors["primary-800"],
    },
    "primary-700": {
      colorKey: "primary-700",
      colorValue: colors["primary-700"],
    },
    "primary-600": {
      colorKey: "primary-600",
      colorValue: colors["primary-600"],
    },
    "primary-500": {
      colorKey: "primary-500",
      colorValue: colors["primary-500"],
    },
    "primary-400": {
      colorKey: "primary-400",
      colorValue: colors["primary-400"],
    },
    "primary-300": {
      colorKey: "primary-300",
      colorValue: colors["primary-300"],
    },
    "primary-200": {
      colorKey: "primary-200",
      colorValue: colors["primary-200"],
    },
    "primary-100": {
      colorKey: "primary-100",
      colorValue: colors["primary-100"],
    },
    "primary-50": { colorKey: "primary-50", colorValue: colors["primary-50"] },
    "primary-alpha-24": {
      colorKey: "primary-alpha-24",
      colorValue: colors["primary-alpha-24"],
    },
    "primary-alpha-16": {
      colorKey: "primary-alpha-16",
      colorValue: colors["primary-alpha-16"],
    },
    "primary-alpha-10": {
      colorKey: "primary-alpha-10",
      colorValue: colors["primary-alpha-10"],
    },
    "primary-alpha-0": {
      colorKey: "primary-alpha-0",
      colorValue: colors["primary-alpha-0"],
    },
    "primary-base": {
      colorKey: "primary-500",
      colorValue: colors["primary-500"],
    },
    "primary-dark": {
      colorKey: "primary-700",
      colorValue: colors["primary-700"],
    },
    "static-static-black": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "static-static-white": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "bg-strong-950": {
      colorKey: "neutral-100",
      colorValue: colors["neutral-100"],
    },
    "bg-surface-800": {
      colorKey: "neutral-200",
      colorValue: colors["neutral-200"],
    },
    "bg-sub-300": {
      colorKey: "neutral-600",
      colorValue: colors["neutral-600"],
    },
    "bg-soft-200": {
      colorKey: "neutral-700",
      colorValue: colors["neutral-700"],
    },
    "bg-weak-50": {
      colorKey: "neutral-900",
      colorValue: colors["neutral-900"],
    },
    "bg-white-0": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "text-strong-900": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "text-sub-600": {
      colorKey: "neutral-400",
      colorValue: colors["neutral-400"],
    },
    "text-soft-400": {
      colorKey: "neutral-500",
      colorValue: colors["neutral-500"],
    },
    "text-disabled-300": {
      colorKey: "neutral-600",
      colorValue: colors["neutral-600"],
    },
    "text-white-0": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "stroke-strong-950": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "stroke-sub-300": {
      colorKey: "neutral-600",
      colorValue: colors["neutral-600"],
    },
    "stroke-soft-200": {
      colorKey: "neutral-700",
      colorValue: colors["neutral-700"],
    },
    "stroke-white-0": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "icon-strong-950": {
      colorKey: "neutral-0",
      colorValue: colors["neutral-0"],
    },
    "icon-sub-600": {
      colorKey: "neutral-400",
      colorValue: colors["neutral-400"],
    },
    "icon-soft-400": {
      colorKey: "neutral-500",
      colorValue: colors["neutral-500"],
    },
    "icon-disabled-300": {
      colorKey: "neutral-600",
      colorValue: colors["neutral-600"],
    },
    "icon-white-0": {
      colorKey: "neutral-950",
      colorValue: colors["neutral-950"],
    },
    "state-faded-dark": {
      colorKey: "neutral-300",
      colorValue: colors["neutral-300"],
    },
    "state-faded-base": {
      colorKey: "neutral-500",
      colorValue: colors["neutral-500"],
    },
    "state-faded-light": {
      colorKey: "alpha-colors-neutral-alpha-24",
      colorValue: colors["alpha-colors-neutral-alpha-24"],
    },
    "state-faded-lighter": {
      colorKey: "alpha-colors-neutral-alpha-16",
      colorValue: colors["alpha-colors-neutral-alpha-16"],
    },
    "state-information-dark": {
      colorKey: "blue-400",
      colorValue: colors["blue-400"],
    },
    "state-information-base": {
      colorKey: "blue-500",
      colorValue: colors["blue-500"],
    },
    "state-information-light": {
      colorKey: "alpha-colors-blue-alpha-24",
      colorValue: colors["alpha-colors-blue-alpha-24"],
    },
    "state-information-lighter": {
      colorKey: "alpha-colors-blue-alpha-16",
      colorValue: colors["alpha-colors-blue-alpha-16"],
    },
    "state-warning-dark": {
      colorKey: "orange-400",
      colorValue: colors["orange-400"],
    },
    "state-warning-base": {
      colorKey: "orange-600",
      colorValue: colors["orange-600"],
    },
    "state-warning-light": {
      colorKey: "alpha-colors-orange-alpha-24",
      colorValue: colors["alpha-colors-orange-alpha-24"],
    },
    "state-warning-lighter": {
      colorKey: "alpha-colors-orange-alpha-16",
      colorValue: colors["alpha-colors-orange-alpha-16"],
    },
    "state-error-dark": {
      colorKey: "red-400",
      colorValue: colors["red-400"],
    },
    "state-error-base": {
      colorKey: "red-600",
      colorValue: colors["red-600"],
    },
    "state-error-light": {
      colorKey: "alpha-colors-red-alpha-24",
      colorValue: colors["alpha-colors-red-alpha-24"],
    },
    "state-error-lighter": {
      colorKey: "alpha-colors-red-alpha-16",
      colorValue: colors["alpha-colors-red-alpha-16"],
    },
    "state-success-dark": {
      colorKey: "green-400",
      colorValue: colors["green-400"],
    },
    "state-success-base": {
      colorKey: "green-600",
      colorValue: colors["green-600"],
    },
    "state-success-light": {
      colorKey: "alpha-colors-green-alpha-24",
      colorValue: colors["alpha-colors-green-alpha-24"],
    },
    "state-success-lighter": {
      colorKey: "alpha-colors-green-alpha-16",
      colorValue: colors["alpha-colors-green-alpha-16"],
    },
    "state-away-dark": {
      colorKey: "yellow-400",
      colorValue: colors["yellow-400"],
    },
    "state-away-base": {
      colorKey: "yellow-600",
      colorValue: colors["yellow-600"],
    },
    "state-away-light": {
      colorKey: "alpha-colors-yellow-alpha-24",
      colorValue: colors["alpha-colors-yellow-alpha-24"],
    },
    "state-away-lighter": {
      colorKey: "alpha-colors-yellow-alpha-16",
      colorValue: colors["alpha-colors-yellow-alpha-16"],
    },
    "state-feature-dark": {
      colorKey: "purple-400",
      colorValue: colors["purple-400"],
    },
    "state-feature-base": {
      colorKey: "purple-500",
      colorValue: colors["purple-500"],
    },
    "state-feature-light": {
      colorKey: "alpha-colors-purple-alpha-24",
      colorValue: colors["alpha-colors-purple-alpha-24"],
    },
    "state-feature-lighter": {
      colorKey: "alpha-colors-purple-alpha-16",
      colorValue: colors["alpha-colors-purple-alpha-16"],
    },
    "state-verified-dark": {
      colorKey: "sky-400",
      colorValue: colors["sky-400"],
    },
    "state-verified-base": {
      colorKey: "sky-500",
      colorValue: colors["sky-500"],
    },
    "state-verified-light": {
      colorKey: "alpha-colors-sky-alpha-24",
      colorValue: colors["alpha-colors-sky-alpha-24"],
    },
    "state-verified-lighter": {
      colorKey: "alpha-colors-sky-alpha-16",
      colorValue: colors["alpha-colors-sky-alpha-16"],
    },
    "state-highlighted-dark": {
      colorKey: "pink-400",
      colorValue: colors["pink-400"],
    },
    "state-highlighted-base": {
      colorKey: "pink-600",
      colorValue: colors["pink-600"],
    },
    "state-highlighted-light": {
      colorKey: "alpha-colors-pink-alpha-24",
      colorValue: colors["alpha-colors-pink-alpha-24"],
    },
    "state-highlighted-lighter": {
      colorKey: "alpha-colors-pink-alpha-16",
      colorValue: colors["alpha-colors-pink-alpha-16"],
    },
    "state-stable-dark": {
      colorKey: "teal-400",
      colorValue: colors["teal-400"],
    },
    "state-stable-base": {
      colorKey: "teal-600",
      colorValue: colors["teal-600"],
    },
    "state-stable-light": {
      colorKey: "alpha-colors-teal-alpha-24",
      colorValue: colors["alpha-colors-teal-alpha-24"],
    },
    "state-stable-lighter": {
      colorKey: "alpha-colors-teal-alpha-16",
      colorValue: colors["alpha-colors-teal-alpha-16"],
    },
  },
};
